import { API } from "aws-amplify"
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"

const fetchTags = async organization_id => {
  const params = [
    `organization_id=${organization_id}`,
    "category=S",
    "object_type=project",
  ].join("&")
  const res = await API.get("CORE", `/tags?${params}`)

  return res
}

export const useOrganizacionTags = (organization_id, enabled = false) => {
  return useQuery({
    queryKey: ["organization-tags", organization_id],
    queryFn: () => fetchTags(organization_id),
    enabled,
  })
}

export const useCreateOrganizacionTag = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async data => {
      return await API.post("CORE", "/tags", { body: data })
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["organization-tags", variables.organization_id],
      })
    },
  })
}

export const useDeleteOrganizacionTag = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ organization_id, sk }) => {
      return await API.del("CORE", "/tags", {
        body: {
          organization_id,
          sks: [sk],
        },
      })
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["organization-tags", variables.organization_id],
      })
    },
  })
}
